import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import { Label } from '~/modules/coreUI/components/basic/Labels';
import { Column, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Icon from '~/modules/coreUI/components/basic/Icon';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import BasicLink from '~/modules/ecommerceCoreUI/components/basic/Link';

const CommaSeparator = (optionValuesLength, currentOptionValue) => {
  let comma = ',';
  if (currentOptionValue === optionValuesLength - 1) {
    comma = '';
  }
  return comma;
};

const OfferedVariants = ({ offeredVariants }) => (
  <React.Fragment>
    <Column spaceBetween={1} leftAligned>
      <Label semiBold important size={['md', 'md', 'lg', 'lg']}>
        {i18next.t('ecommerceCoreUI:Product.offerItemsTitle')}
      </Label>
      <Spacer size={0.2} />
      {offeredVariants.map(offeredVariant => (
        <Row spaceBetween={0.5} topAligned leftAligned key={offeredVariant.variant.ref_id}>
          <Icon secondary className="el-icon el-icon-offer-label-tag" />
          <Column spaceBetween={0.5} leftAligned>
            <Row spaceBetween={1} topAligned secondary>
              <BasicLink targeturl={urlFor('getProductDetailsLink', [offeredVariant.variant.slug, offeredVariant.variant.vendor_variants_count, offeredVariant.variant.min_variant?.vendor])} secondary>
                <Label secondary size={['sm', 'sm', 'md', 'md']} semiBold>
                  {offeredVariant.variant.product_name}
                </Label>
              </BasicLink>
              <Label size={['xs', 'xs', 'sm', 'sm']} semiBold>
                {`(X${offeredVariant.quantity})`}
              </Label>
            </Row>
            <Row spaceBetween={0.5}>
              {offeredVariant.variant.option_values.length > 0 && offeredVariant.variant.option_values.map((optionValue, index) => (
                <Label key={optionValue.ref_id} size={['xs', 'xs', 'sm', 'sm']} semiBold>
                  {optionValue.presentation}
                  {CommaSeparator(offeredVariant.variant.option_values.length, index)}
                </Label>
              ))}
            </Row>
          </Column>
        </Row>
      ))}
    </Column>
    <Spacer size={2} />
  </React.Fragment>
);

OfferedVariants.propTypes = {
  offeredVariants: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default OfferedVariants;
